import { useContext } from "react"
import { CommandCenterStateProviderContext } from "../context";
import { LaunchDetails } from "../types";
import MissionService from "../../../service/MissionService";
import useUrlParams from "./useUrlParams";


const useOrbit = () => {
    const { sat_id } = useUrlParams()
    const context = useContext(CommandCenterStateProviderContext)
    if (context === undefined) {
        throw new Error('useContacts must be used within a ViewerProvider');
    }

    const { orbitData, orbitParams, launchDetails, setOrbitData, setOrbitParams, setLaunchDetails } = context
    const getLaunchDetails = () => {
        MissionService.getAllOrbitDetails(sat_id).then(res => {
            if (res.data) {
                const launchDetails = res.data.sort((a: LaunchDetails, b: LaunchDetails) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                setLaunchDetails(launchDetails)
            }
        }).catch(err => {
            console.log(err)
        })
    }
    return { orbitData, orbitParams, launchDetails, setOrbitData, setOrbitParams, setLaunchDetails, getLaunchDetails }
}

export default useOrbit